<template>
  <div class="comparison-grid" style="width:100%">
    <ag-grid-vue
      class="ag-theme-alpine"
      style="width: 100%; height: 320px;"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="items"
      rowSelection="single"
      @grid-ready="onGridReady"
      @row-clicked="onRowClicked"
    />
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'

export default {
  name: 'ComparisonGrid',
  components: { AgGridVue },
  props: { items: { type: Array, default: () => [] } },
  data() {
    return {
      gridApi: null,
      columnApi: null,
      defaultColDef: {
        sortable: false,
        filter: true,
        resizable: true,
        flex: 1,
        minWidth: 100
      },
      columnDefs: [
        {
          headerName: 'Model A',
          field: 'modelA',
          valueGetter: params => {
            const m = params.data && params.data.models && params.data.models[0]
            return (m && m.name) || params.data.modelsA || ''
          },
          filter: 'agTextColumnFilter',
          sortable: false
        },
        {
          headerName: 'Model B',
          field: 'modelB',
          valueGetter: params => {
            const m = params.data && params.data.models && params.data.models[1]
            return (m && m.name) || params.data.modelsB || ''
          },
          filter: 'agTextColumnFilter',
          sortable: false
        },
        {
          headerName: 'Created',
          field: 'createdAt',
          valueGetter: params => (params.data && (params.data.createdAt || params.data.timestamp)) || '',
          filter: 'agDateColumnFilter',
          sortable: true
        },
        {
          headerName: 'Status',
          field: 'status',
          filter: 'agSetColumnFilter',
          sortable: false
        }
      ]
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
      if (this.items && this.gridApi) this.gridApi.setRowData(this.items)
    },
    onRowClicked(event) {
      const item = event && event.data ? event.data : null
      if (!item) return
      if (this.$router && item && item.jobId) {
        this.$router.push({ name: 'LLMComparisonViewer', params: { id: item.jobId } })
        return
      }
      this.$emit('open', item)
    },
    updateRow(jobId, updatedData) {
      if (!this.gridApi) return
      const rowNode = this.findRowByJobId(jobId)
      if (rowNode) {
        rowNode.setData(updatedData)
      }
    },
    findRowByJobId(jobId) {
      if (!this.gridApi) return null
      let foundNode = null
      this.gridApi.forEachNode(node => {
        if (node.data && node.data.jobId === jobId) {
          foundNode = node
        }
      })
      return foundNode
    }
  },
  watch: {
    items(newVal) {
      if (this.gridApi) this.gridApi.setRowData(newVal || [])
    }
  }
}
</script>

<style scoped>
.comparison-grid { min-height: 200px }
</style>
